module.exports = __webpack_public_path__ + "static/73-8efcd93ff341f45951006b23483c28fa.png";